import { render } from "./editpurchaseorder.vue?vue&type=template&id=6bba73a9&scoped=true"
import script from "./editpurchaseorder.vue?vue&type=script&lang=js"
export * from "./editpurchaseorder.vue?vue&type=script&lang=js"

import "./editpurchaseorder.vue?vue&type=style&index=0&id=6bba73a9&scoped=true&lang=css"

import exportComponent from "/Users/zonegoh/Documents/GitHub/levelup/level-up/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bba73a9"]])

export default __exports__